module.exports = __webpack_public_path__ + "img/member-crown.83e636de.png";